import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { XAxisButton } from '@/common/dashboard/XAxisButton';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useMemo } from 'react';

export const InctvRbtTrendCard = ({ xAxisOptions, metricOptions }) => {
  const { formValues } = useForm();
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();

  const reqParam = useMemo(
    () => ({
      metric: formValues.metric,
      prodExpr: formValues.prodExpr,
      progExpr: formValues.progExpr,
      custExpr: formValues.custExpr,
      ctrtExpr: formValues.ctrtExpr,
      rbtPeriodExpr: formValues.rbtPeriodExpr,
      earnedPeriodExpr: formValues.earnedPeriodExpr,
      xAxis: formValues.xAxis,
    }),
    [
      formValues.metric,
      formValues.prodExpr,
      formValues.progExpr,
      formValues.custExpr,
      formValues.ctrtExpr,
      formValues.rbtPeriodExpr,
      formValues.earnedPeriodExpr,
      formValues.xAxis,
    ],
  );

  const navigateToInctvRbtLineList = (point) => {
    const entity = 'INCTV_RBT_LINE';
    rsrc
      .data('sc', 'INCTV_RBT_LINE_EXPR_DATA_PLUGIN', { ...reqParam, category: point.category, entity }, entity)
      .then((expr) => navigateTo('sc/inctv-rbt-line', { mode: Mode.LIST, expr }));
  };

  const metric =
    metricOptions
      .filter((option) => formValues.metric?.includes(option.value))
      .map((option) => option.displayName)
      .join(' & ') || metricOptions[0].displayName;
  const xAxisLabel = xAxisOptions.find((option) => option.code === formValues.xAxis)?.displayName;
  return (
    <DashboardCard
      title={metric + ' by ' + xAxisLabel}
      description={'Displays the Incentive Rebate Lines ' + metric + ' by ' + xAxisLabel}
      module="sc"
      plugin="INCTV_TREND_DATA_PLUGIN"
      reqParam={reqParam}
      buttons={<XAxisButton options={xAxisOptions} />}
    >
      {(data) => (
        <CartesianChart
          rotateXLabels={false}
          onClick={(point) => navigateToInctvRbtLineList(point)}
          data={data}
          legend="top"
          yLabel={metric}
          allowNegative
        />
      )}
    </DashboardCard>
  );
};
